import React from 'react';
import urlBase from '../../url-base';
import axios from 'axios';
import InputMask from 'react-input-mask';
import { List, ListItem } from 'material-ui/List';
import logoDental from '../../assets/images2/new_layout/logo_dental_principal.svg'; // <--- Adicione esta linha!
import {
  Alert, Container, Row, Col, Button
} from 'reactstrap';
// NL import MenuNew from '../MenuNew';
// NL import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';
//import Contact from '../HomePageNew/Contact';
import { Scrollbars } from 'react-custom-scrollbars';
import {Link} from 'react-router';
import Dialog from 'material-ui/Dialog';
import '../../assets/css/custom.css';


class PaymentSlip extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      secondPayment : [],
      urlSecondPayment : "",
      layout : false,
      collapse : false,
      index : 0,
      openModal: false,
      active:"",
      planList:[],
    };

    this.toggle = this.toggle.bind(this);
    this.styles = {
      item:{        
        backgroundColor: '#fff!important',
        border: 'solid 0.5px #f0f0f0!important'
      }
    };
  }

  componentWillMount() {

  }
  componentDidMount() {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
  }
  validateCpfContract(cpf) {
    //console.log(cpf);
    let	urlCpf = urlBase.loopBack+'APIS4s/ValidarCPF';
    let	dataPost = {
      cpf: cpf
    };

    return axios.post(urlCpf, dataPost).then((result) => {
      if(result.data == null)
        return false;//retorna false, cpf nao encontrado
      else{
        //console.log(result);
        let contracts = result.data, cont=0;
        for(let i=0; i<contracts.length; i++){
          if(contracts[i].situacaoDescricao.indexOf("CANCELADO") == -1)
            cont++;
        }
        if(cont > 0)
          return "PERMITIDO";
        else
          return "CANCELADO";
      }
    })
    .catch(function (error) {
      alert("Erro", error);//alert erro caso seja informado cpf vazio ou invalido, para esse endpoint
    }.bind(this));
  }
  toggle(index) {
    let url = this.state.secondPayment[index].UrlBoleto;
    this.setState({ collapse: !this.state.collapse, urlSecondPayment: url, index : index });
  }
	validateCpf(id, event){
    this.state.planList = [];
    this.setState(this.state);
    event.preventDefault();

    let cpf  = document.getElementById(id).value.replace(/[^0-9]/g,'');
    document.getElementById('loading_second_payment_cpf').style.display = 'block';
    let test = true;
    let add  = 0, i = 0, rev = 0;

    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"){
      test = false;
    }else{
      // Valida 1° digito
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11){
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){
          test = false;
        }
      // Valida 2° digito
      add = 0;
      for (i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))) {
        test = false;
      }
    }

    
    if (test == true) {
      document.getElementById("alert_second_payment_cpf").style.display = "none";
      this.form_cpf();
    }
    else {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "*CPF inválido!";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
      let state = this.state;
      state.secondPayment = [];
      //state.layout = false;
      this.setState(state);
    }
  }
  //busca dados do usuario no endpoint - usuarios
	form_cpf() {
    let cpf = document.getElementById("second_payment_cpf").value;
    this.validateCpfContract(cpf).then(cpfActive => {
      this.setState({active: cpfActive});
      if(cpfActive != false){//cpf encontrado

        let	url = urlBase.loopBack+'APIS4s/Associados_legado';
        let	dataPost = {
          cpf: cpf
        };
        let ativo = new Array();
        let toSearch = new Array();
        let plans = new Array();  
        let isBoleto = false;
        axios.post(url, dataPost)
        .then((result) => {
          //console.log(result.data);
         
         console.dir(result.data)
          if (result.data.length > 0) {            
            
            /** Porque comparando > 1 (quando mudar para 0, funciona - Paulo*/

            if (result.data.length>0){
              // let remover = false;
              result.data.forEach(function (itens, index) {              
                itens.Dependente.forEach(function (itm) {
                    isBoleto = (itm.NomeEmpresa.indexOf("SISTEMA BANCARIO") != -1 )
                    let check = itm.NomeSituacao;
                   
                    if (check == 'CANCELADO') {
                      //remover = true;
                    } else {
                      //remover = false;
                      ativo.push(result.data[index]);
                    }                  
                })

              });              
            }
            if (isBoleto) {
                  let allIndex = ativo.map(item => item.Id)
                  .filter((value, index, self) => self.indexOf(value) === index);
                result.data.forEach(function (itens, index) {
                  allIndex.forEach(function (itn) {
                    if (itens.Id == itn){
                      toSearch.push(result.data[index]);
                    }
                  })
                })

                if (toSearch.length==1){
                  let code = [toSearch[0].Id];
                  this.second_payment_slip(code);
                }else{                         
                  //exibir o nome dos planos   
                  toSearch.forEach(function(item){
                    plans.push({
                      'id': item.Id,
                      'nome': item.Dependente[0].NomePlano
                    })
                  })                          
                  
                  this.state.planList = plans;
                  this.setState(this.state);  

                }              

            }else {
              document.getElementById('loading_second_payment_cpf').style.display = 'none';
              document.getElementById("alert_second_payment_cpf").innerHTML = "Tipo de plano não permite pagamento por boleto.";
              document.getElementById("alert_second_payment_cpf").style.display = "block";
              let state = this.state;
              state.secondPayment = [];
              this.setState(state);
            }
 

            
            
          }
          else {
            document.getElementById('loading_second_payment_cpf').style.display = 'none';
            document.getElementById("alert_second_payment_cpf").innerHTML = "CPF não encontrado, entre em contado com a dental center através do número (83) 3041-4646";
            document.getElementById("alert_second_payment_cpf").style.display = "block";
            let state = this.state;
            state.secondPayment = [];
            this.setState(state);
          }
        })
        .catch(function () {
          document.getElementById('loading_second_payment_cpf').style.display = 'none';
          document.getElementById("alert_second_payment_cpf").innerHTML = "Ocorreu um erro ao buscar os dados do CPF";
          document.getElementById("alert_second_payment_cpf").style.display = "block";
          let state = this.state;
          state.secondPayment = [];
          this.setState(state);
        }.bind(this));
      }else{
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").innerHTML = "CPF não encontrado, entre em contado com a dental center através do número (83) 3041-4646";
        document.getElementById("alert_second_payment_cpf").style.display = "block";
      }
    });
  }
  //faz a busca da segunda via do boleto pelo codigo(que é o id do usuario), no endpoint mensalidades

  selectPlan(code){
    let idSearch = [code];
    this.second_payment_slip(idSearch);
  }
  // Paulo - verificar o tipo de pagamento
  // atributo: DescricaoPagamento - UrlBoleto
  //  "TipoPagamento": "34"
  // Msg: tipo de plano do cliente não permite pagamento por boleto.
  second_payment_slip(code) {
    let	url = urlBase.loopBack+'APIS4s/Mensalidades';

    let	dataPost = {
      codigo: code
    };

    axios.post(url, dataPost)
    .then((result) => {
      if (result.data.length > 0) {
        let state = this.state;
        state.secondPayment = result.data.reverse();
        state.layout = true;
        this.setState(state);
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").style.display = "none";
        this.onOpenModal();
      }
      else {
        document.getElementById('loading_second_payment_cpf').style.display = 'none';
        document.getElementById("alert_second_payment_cpf").innerHTML = "Boletos não encontratos para este CPF";
        document.getElementById("alert_second_payment_cpf").style.display = "block";
        let state = this.state;
        state.secondPayment = [];
        this.setState(state);
      }
    })
    .catch(function () {
      document.getElementById('loading_second_payment_cpf').style.display = 'none';
      document.getElementById("alert_second_payment_cpf").innerHTML = "Ocorreu um erro ao buscar os boletos para este CPF";
      document.getElementById("alert_second_payment_cpf").style.display = "block";
      let state = this.state;
      state.secondPayment = [];
      this.setState(state);
    }.bind(this));
  }
  onOpenModal() {
    this.setState({ openModal: true });
  }
  onCloseModal() {
    this.setState({ openModal: false });
  }

  render() {
    return (

      <div style={{ backgroundColor: '#ffffff' }}>
            <div className="main_navigation_bar">
                <img src={logoDental} alt="Logo Dental Center" className="nav_logo"/>   
                <div className="nav_links_wrapper">
                    <a href="https://institucional.planodentalcenter.com.br/" className="nav_link">Institucional</a>
                    <a href="https://vendas.planodentalcenter.com.br/" className="nav_link">Nossos Planos</a>
                    <a href="https://vendas.planodentalcenter.com.br/para-empresa" className="nav_link">Para sua empresa</a>
                    <a href="https://institucional.planodentalcenter.com.br/faq" className="nav_link">FAQ</a>
                </div>                           
            </div>
            <br/>
            <Container id="payment_slip" >  
                  {/* Botão Voltar para o home 
                  <Row style={{marginLeft: 80}}>
                      <Col style={{marginTop:30}} xs="12" sm="12" md="8" lg="8" xl="8">
                          <Link href="https://institucional.planodentalcenter.com.br/">
                              <Button
                                          className="button_voltar"
                                          type="submit"
                                        >
                                      ← Voltar para Home
                              </Button>                            
                          </Link>

                      </Col> 
                  </Row>
      */}
                  <div className="payment_slip_img" >   
                      <Row style={{marginRight: 0}}>
                        <Col style={{marginTop:30}} xs="12" sm="12" md="2" lg="2" xl="2">
                            {/* Imagens 1
                            <div className="payment_slip_img_1"> </div> 
                             */}
                        </Col>

                        <Col id="payment_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                          <h1>
                            Boleto digital
                          </h1>
                          <p>
                            Retire seu boleto de pagamento de maneira simpes e rápida
                          </p>

                          <form onSubmit={this.validateCpf.bind(this, "second_payment_cpf")}>
                            <label>Insira o <b style={{ color: '#1b7d93' }}>CPF do titular</b> abaixo</label>
                            
                            
                            {this.state.planList.length > 0 ? (
                              <p>VOCÊ POSSUI MAIS DE UM PLANO ATIVO SELECIONE</p>                  
                            ) : null}

                            <List>                                        

                              {this.state.planList.map((item,i) => {                      
                                return <ListItem key={i} className='item_list' onClick={() => this.selectPlan(item.id)}  primaryText={item.nome} />                                           
                              })}

                            </List>
                            <div>
                              <div id="loading_second_payment_cpf">
                                  <i className="fa fa-sync fa-spin"></i>
                                  <span class="sr-only"> Aguarde...</span>   
                              </div>
                             <br/>                              

                              <Alert  color='danger' styles={{ fontSize: 20 }} id="alert_second_payment_cpf">{''}</Alert>

                              <InputMask
                                id="second_payment_cpf"
                                className="ant-input input_second_payment"
                                mask="999.999.999-99"
                                maskChar=" "
                                type="tel"
                                onBlur={this.validateCpf.bind(this, "second_payment_cpf")}
                                placeholder="CPF DO TITULAR*"
                              />
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <Button
                                className="button_you_family"
                                onClick={this.validateCpf.bind(this, "second_payment_cpf")}
                                type="submit"
                              >
                                Buscar
                              </Button>                    
                            </div>

                          </form>
                        </Col>              
                        <Col style={{marginTop:10}} xs="12" sm="12" md="2" lg="2" xl="2">
                            <Row>
                                  <Col>
                                        {/* Imagens 3
                                        <div className="payment_slip_img_3">  </div>        
                                        */}
                                  </Col>
                              </Row>
                              <Row>
                                    <Col>
                                            {/* Imagens 2 
                                        <div className="payment_slip_img_2">  </div>  
                                        */}                   
                                    </Col>                                 
                            </Row>
               

                        </Col>             
                      </Row>

                  </div>

            </Container>

            <Dialog
              open={this.state.openModal}
              //onRequestClose={this.onCloseModal.bind(this)}
              showCloseIcon={false}
              title={
                <div>
                  <div className="logo_modal navbar-brand">&nbsp;</div>
                  <i
                    id="modal_payment_slip_close_modal"
                    className="fas fa-times-circle color_fa"
                    onClick={this.onCloseModal.bind(this)}
                  >{''}</i>
                  <h2 className="modal_payment_slip_title">SEUS BOLETOS</h2>
                </div>
              }
            >
              <Scrollbars style={{ width: '100%', height: 300, padding: '0 8px' }}>
                <div id="modal_payment_slip_title_list">
                {this.state.secondPayment.map((item, index) =>
                  <div key={index} value={item.UrlBoleto} id="margin_iframe">
                    {this.state.active == "PERMITIDO" ? (//CASO NAO SEJA CANCELADO
                      <Link style={{color:"#757575"}} target="_blank" to={this.state.urlSecondPayment}>
                        <p onClick={this.toggle.bind(this, index)}>
                          {item.DataVencimento}
                          {item.DescricaoParcela == "PARCELA VIRTUAL" ? (
                            " - ACORDO"
                          ):(
                            ""
                          )}
                        </p>
                      </Link>
                    ):(
                      <p onClick={this.toggle.bind(this, index)}>
                        {item.DataVencimento}
                        {item.DescricaoParcela == "PARCELA VIRTUAL" ? (
                          " - ACORDO"
                        ):(
                          ""
                        )}
                      </p>
                    )}


                    {/*{this.state.index == index ? (
                      <Collapse isOpen={this.state.collapse}>
                        <iframe src = {this.state.urlSecondPayment} width="100%" height="500">
                          &nbsp;
                        </iframe>
                      </Collapse>
                      ):('')
                    }*/}
                    <hr />
                  </div>
                )}
                </div>
              </Scrollbars>
            </Dialog>

            {/* Retirar a seção de contatos da página 
            <Contact />
            */}
            <Footer />
      </div>

    );
  }
}
export default PaymentSlip;



/** WEBPACK FOOTER **
 ** ./src/components/SecondPaymentSlipNew/PaymentSlip.js
 **/